import { render, staticRenderFns } from "./CcMy.vue?vue&type=template&id=722ce06a&scoped=true"
import script from "./CcMy.vue?vue&type=script&lang=js"
export * from "./CcMy.vue?vue&type=script&lang=js"
import style0 from "./CcMy.vue?vue&type=style&index=0&id=722ce06a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722ce06a",
  null
  
)

export default component.exports